import { cn } from "@/shared/lib"

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      // Verdant skeletons shimmer (1.6s sweep), they do not pulse.
      className={cn(
        "animate-shimmer rounded-lg bg-linear-to-r from-surface-1 via-surface-3 to-surface-1 bg-[length:200%_100%]",
        className
      )}
      {...props}
    />
  )
}

export { Skeleton }
